<template>
  <div class="container margin_80_55">
    <div class="row  mt-5">
      <div class="col-lg-9" v-if="blogInfo">
        <div class="bloglist singlepost">
          <h1>{{ blogInfo.Title }}</h1>
          <div class="postmeta">
            <ul>
              <li>
                <i class="icon_clock_alt"></i>
                {{
                  new Date(blogInfo.UpdateDate)
                    .toLocaleString()
                    .replace(",", "")
                    .replace(/:.. /, " ")
                }}
              </li>
              <li>
                <i class="icon_pencil-edit"></i>
                {{ blogInfo.UserName }}
              </li>
            </ul>
          </div>
          
          <!-- /post meta -->
          <div class="post-content">
            <div class="">
              <p v-html="blogInfo.Body"></p>
            </div>
          </div>
          <!-- /post -->
        </div>
        <!-- /single-post -->
      </div>
      <!-- /col -->

      <aside class="col-lg-3 bg-white h-100" >
        <!-- Share Section -->
        <div class="widget">
          <div class="widget-title">
            <h4>Share</h4>
          </div>
          <div class="share-buttons">
            <button 
              @click="shareToFacebook" 
              class="share-btn facebook"
              title="Share to Facebook"
            >
              <i class="fa fa-facebook"></i>
              <span>Share to Facebook</span>
            </button>
            
            <button 
              @click="shareToLinkedIn" 
              class="share-btn linkedin"
              title="Share to LinkedIn"
            >
              <i class="fa fa-linkedin"></i>
              <span>Share to LinkedIn</span>
            </button>
            
            <!-- <button 
              @click="shareToInstagram" 
              class="share-btn instagram"
              title="Copy link for Instagram"
            >
              <i class="fa fa-instagram"></i>
              <span>Share to Instagram</span>
            </button> -->
          </div>
        </div>

        <!-- /widget -->
        <div class="widget">
          <div class="widget-title">
            <h4>Recent Posts</h4>
          </div>
          <ul class="comments-list" v-if="bloglist">
            <li  v-for="(bloglistitem, index) in bloglist"
            :key="index">
              
              <small>{{ bloglistitem.UserName }}</small>
              <h3>
                  <a href="javascript:void(0)" @click="reloadToDetailsPg(bloglistitem.ID)"> {{ bloglistitem.Title }}</a>
                
                <!-- <router-link
                  :to="{
                    name: 'BlogDetails',
                    params: { blogId: bloglistitem.ID },
                  }"
                  >{{ bloglistitem.Title }}</router-link
                > -->
              </h3>
            </li>
          </ul>
        </div>

        <!-- /widget -->
        <!-- <div class="widget">
          <div class="widget-title">
            <h4>Popular Tags</h4>
          </div>
          <div class="tags">
            <a href="#">Information tecnology</a>
            <a href="#">Students</a>
            <a href="#">Community</a>
            <a href="#">Carreers</a>
            <a href="#">Literature</a>
            <a href="#">Seminars</a>
          </div>
        </div> -->
        <!-- /widget -->
      </aside>
      <!-- /aside -->
    </div>
    <!-- /row -->
  </div>
</template>
<script>
import BlogService from '../services/blog-service'
import _ from 'lodash'
export default {
  name: 'BlogDetails',
  data() {
    return {
      blogInfo: [],
      bloglist: [],
    }
  },
  watch: {
    $route () {
      this.getBlogInfo(this.$route.params.Id)
    }
  },
  mounted() {
    this.getBlogInfo(this.$route.params.Id)
    this.getBlogs()
  },
  methods: {
    getBlogInfo(Id) {
      BlogService.getBlogInformation(Id).then((response) => {
        this.blogInfo = response.data.Object.blog
      }),
      (error) => {
        console.log(error)
      }
    },
    getBlogs() {
      BlogService.getBlogList().then((response) => {
        this.bloglist = _.orderBy(response.data.Object.blogs).slice(0, 3)
      }),
      (error) => {
        console.log(error)
      }
    },
    reloadToDetailsPg(blogId){
      this.$router.push({ name: 'BlogDetails', params: { Id: blogId } }, )
      this.getBlogInfo(blogId)
    },
    getCurrentUrl() {
      return window.location.href
    },
    shareToFacebook() {
      const url = this.getCurrentUrl()
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
      window.open(facebookUrl, '_blank')
    },
    shareToLinkedIn() {
      const url = this.getCurrentUrl()
      const linkedInUrl = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(url)}`
      window.open(linkedInUrl, '_blank')
    },
    fallbackCopyToClipboard(text) {
      // Fallback method for older browsers
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      
      try {
        document.execCommand('copy')
        alert('Link copied to clipboard! You can now paste it in Instagram.')
      } catch (err) {
        alert(`Please copy this link manually: ${text}`)
      }
      
      document.body.removeChild(textArea)
    }
  },
}
</script>

<style scoped>
.share-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  text-align: left;
}

.share-btn i {
  font-size: 18px;
  width: 20px;
  text-align: center;
}

.share-btn.facebook {
  background-color: #1877f2;
  color: white;
}

.share-btn.facebook:hover {
  background-color: #166fe5;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 119, 242, 0.3);
}

.share-btn.linkedin {
  background-color: #0077b5;
  color: white;
}

.share-btn.linkedin:hover {
  background-color: #006ba1;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 119, 181, 0.3);
}

.share-btn.instagram {
  background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
  color: white;
}

.share-btn.instagram:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(225, 48, 108, 0.3);
  opacity: 0.9;
}

.widget {
  margin-bottom: 30px;
}
</style>
